import { isEmpty } from 'ramda'

// Function to match new values with original values and use it to send data to BE or get the total amount
export const matchSettleValues = (newValues, selectedValues) => {
  if (!isEmpty(newValues)) {
    newValues.forEach((item) => {
      const matched = selectedValues.find(
        (settle) => settle.invoiceData.id === item.invoiceId
      )
      matched.invoiceData.amount = item.amount * 100
    })
  }
  return selectedValues
}

// Improve settlement error when an invoice has a staged settlement to be accepted
export const settlementError = (errMessage, selected) => {
  // Get invoice ID from error
  const failedInvoiceID = errMessage.split('Invoice ')[1].substring(0, 36)
  let reference

  // Find that has failed matching with invoice ID got from error
  selected.find((invoice) => {
    if (invoice.invoiceData.id === failedInvoiceID)
      reference = invoice.invoiceData.reference
  })

  // Format error
  if (errMessage.includes('has a staged settlement')) {
    return errMessage.split('desc = ')[1].replace(failedInvoiceID, reference)
  } else {
    return errMessage
  }
}
